var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.goodsList.length === 0
      ? _c(
          "div",
          { staticStyle: { padding: "30px 0", "text-align": "center" } },
          [_vm._v("\n    商品列表\n  ")]
        )
      : _c("div", [
          _c("div", { staticStyle: { padding: "0 2px" } }, [
            _vm.goodsActivity.layout == 0
              ? _c(
                  "div",
                  _vm._l(_vm.goodsList, function (items, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "background-color": "#fff",
                          padding: "10px",
                          "margin-bottom": "6px",
                          "border-radius": "8px",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "104px",
                              width: "104px",
                              "font-size": "0",
                            },
                          },
                          [
                            _c("el-image", {
                              staticStyle: {
                                display: "block",
                                "border-radius": "5px",
                              },
                              attrs: { src: items.picUrl, fit: "cover" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "margin-left": "7px" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "long-text",
                                staticStyle: {
                                  "font-weight": "bold",
                                  color: "rgba(0,0,0,0.85)",
                                  "font-size": "13px",
                                },
                              },
                              [_vm._v(_vm._s(items.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "flex-start",
                                  "flex-wrap": "wrap",
                                  margin: "10px 0",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      background: "#FF004F",
                                      color: "#fff",
                                      padding: "2px 3px",
                                      "line-height": "11px",
                                      "border-radius": "3px",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "in-box",
                                        staticStyle: {
                                          "border-right": "1px dashed #fff",
                                          "padding-right": "5px",
                                          "box-sizing": "border-box",
                                        },
                                      },
                                      [_vm._v("返")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "in-box" }, [
                                      _vm._v(
                                        _vm._s(items.goodsDetail.profit || 0)
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      background: "#fff",
                                      color: "#FF004F",
                                      padding: "2px 3px",
                                      border: "1px solid #FF004F",
                                      "margin-left": "3px",
                                      "line-height": "11px",
                                      "border-radius": "3px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "in-box",
                                        staticStyle: {
                                          "border-right": "1px dashed #FF004F",
                                          "padding-right": "5px",
                                          "box-sizing": "border-box",
                                        },
                                      },
                                      [_vm._v("券")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "in-box" }, [
                                      _vm._v(
                                        _vm._s(
                                          items.goodsDetail.couponAmount || 0
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        color: "#282828",
                                      },
                                    },
                                    [_vm._v("到手价")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        color: "#FF0000",
                                        "font-size": "13px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "￥" +
                                          _vm._s(items.goodsDetail.actualPrice)
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#969696",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                已卖" +
                                        _vm._s(items.goodsDetail.salesCount) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "flex-wrap": "wrap",
                    },
                  },
                  _vm._l(_vm.goodsList, function (items, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          width: "49%",
                          "background-color": "#fff",
                          padding: "10px",
                          "margin-bottom": "6px",
                          "border-radius": "8px",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { width: "100%", "font-size": "0" } },
                          [
                            _c("el-image", {
                              staticStyle: {
                                display: "block",
                                "border-radius": "5px",
                              },
                              attrs: { src: items.picUrl, fit: "cover" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", {}, [
                          _c(
                            "div",
                            {
                              staticClass: "long-text",
                              staticStyle: {
                                "font-weight": "bold",
                                color: "rgba(0,0,0,0.85)",
                                "font-size": "13px",
                                "margin-top": "4px",
                              },
                            },
                            [_vm._v(_vm._s(items.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start",
                                "flex-wrap": "wrap",
                                margin: "4px 0",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    background: "#FF004F",
                                    color: "#fff",
                                    padding: "2px 3px",
                                    "line-height": "11px",
                                    "border-radius": "3px",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "in-box",
                                      staticStyle: {
                                        "border-right": "1px dashed #fff",
                                        "padding-right": "5px",
                                        "box-sizing": "border-box",
                                      },
                                    },
                                    [_vm._v("返")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "in-box" }, [
                                    _vm._v(
                                      _vm._s(items.goodsDetail.profit || 0)
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    background: "#fff",
                                    color: "#FF004F",
                                    padding: "2px 3px",
                                    border: "1px solid #FF004F",
                                    "margin-left": "3px",
                                    "line-height": "11px",
                                    "border-radius": "3px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "in-box",
                                      staticStyle: {
                                        "border-right": "1px dashed #FF004F",
                                        "padding-right": "5px",
                                        "box-sizing": "border-box",
                                      },
                                    },
                                    [_vm._v("券")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "in-box" }, [
                                    _vm._v(
                                      _vm._s(
                                        items.goodsDetail.couponAmount || 0
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "8px",
                                      color: "#282828",
                                    },
                                  },
                                  [_vm._v("到手价")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-weight": "bold",
                                      color: "#FF0000",
                                      "font-size": "11px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "￥" +
                                        _vm._s(items.goodsDetail.actualPrice)
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "8px",
                                    color: "#969696",
                                    "margin-top": "2px",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                  已卖" +
                                        _vm._s(items.goodsDetail.salesCount) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }